import useReveal from "../hooks/useReveal";

// Обёртка «появление при скролле»: контент плавно проявляется снизу.
// delay — задержка (мс) для лёгкого каскада; as — тег обёртки (по умолчанию div).
// fadeOnly — без сдвига (только opacity), чтобы не ломать position:sticky внутри.
export default function Reveal({ children, delay = 0, as: Tag = "div", fadeOnly = false, style, ...rest }) {
  const { ref, visible } = useReveal();

  const transform = fadeOnly ? undefined : visible ? "translateY(0)" : "translateY(24px)";
  const transition = fadeOnly
    ? `opacity .6s ease ${delay}ms`
    : `opacity .6s ease ${delay}ms, transform .6s cubic-bezier(.2,.7,.2,1) ${delay}ms`;

  return (
    <Tag
      ref={ref}
      style={{
        opacity: visible ? 1 : 0,
        transform,
        transition,
        willChange: fadeOnly ? "opacity" : "opacity, transform",
        ...style,
      }}
      {...rest}
    >
      {children}
    </Tag>
  );
}
